import { xhrDefaultMessage } from '../../../../../configs/notification';
import { useDispatch, useSelector } from '../../../../../store/store';
import { PaymentMethod } from '../../../../../store/workspace/types';
import { setNotification } from '../../../../../store/general/slice';
import CheckBox from '../../../../../components/CheckBox';
import Spinner from '../../../../../components/Spinner';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    PlusIcon,
    CreditCardIcon,
    SquareCheckIcon,
} from '../../../../../assets/icons';
import {
    setAddNewCardModal,
    setChooseCreditCardModal,
    setPaymentRetryMode,
} from '../../../../../store/workspace/slice';
import {
    getProfileDataThunk,
    purchasePaymentThunk,
    getPaymentMethodsThunk,
    getSubsciptionHistoryThunk,
} from '../../../../../store/workspace/thunks';
import {
    selectPaymentMethods,
    selectFetchingpPaymentMethods,
    selectSelectedPricingPlan,
    selectPaymentRetryMode,
    selectSelectedPlanSeatCount,
} from '../../../../../store/workspace/selectors';

export default function ChooseCard() {
    const dispatch = useDispatch();
    // const paymentMethods = useSelector(selectPaymentMethods);
    const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);
    const [submitingPayment, setSubmitingPayment] = useState(false);
    const seatCount = useSelector(selectSelectedPlanSeatCount);
    const retryMode = useSelector(selectPaymentRetryMode);
    const selectedPlan = useSelector(selectSelectedPricingPlan);
    const [errorMessage, setErrorMessage] = useState('');
    // const fetchingPaymentMethods = useSelector(selectFetchingpPaymentMethods);
    const [fetching, setFetching] = useState(false);
    const [selectedMethod, setSelectedMethod] = useState<PaymentMethod | null>(null);
    const [step, setStep] = useState<'SelectPaymentMethod' | 'Done'>('SelectPaymentMethod');

    useEffect(() => {
        setFetching(true);
        dispatch(getPaymentMethodsThunk({
            action: 'get_payment_methods',
        }))
            .unwrap()
            .then(response => {
                setPaymentMethods(response)
            })
            .catch(e => {
                dispatch(setNotification(['Something went wrong,Please try again...', 'error']));
            })
            .finally(() => {
                setFetching(false);
            })

        return () => {
            dispatch(setPaymentRetryMode(false));
        }
    }, []);

    const next = () => {
        if (retryMode) {
            retryPayment();
            return;
        }

        switch (step) {
            case 'SelectPaymentMethod':
                submitPayment();
                break;
            case 'Done':
                dispatch(setChooseCreditCardModal(false));
                break;
            default:
                return;
        }
    };

    const submitPayment = () => {
        if (!selectedMethod) return;
        setErrorMessage('');
        setSubmitingPayment(true);
        const plan_type = `${selectedPlan?.id}${seatCount === 0 ? '' : `_${seatCount}m`}`

        dispatch(purchasePaymentThunk({
            plan_type,
            pmId: selectedMethod.id,
            action: 'create_subscription',
        }))
            .unwrap()
            .then(() => {
                dispatch(setPaymentRetryMode(false));
                setStep('Done');
                setSubmitingPayment(false);
                dispatch(getProfileDataThunk());
                dispatch(setNotification(['payment has been successfully confirmed', 'success']));

                dispatch(getSubsciptionHistoryThunk({
                    action: 'get_subscription_status',
                }));
            })
            .catch(e => {
                setSubmitingPayment(false);
                setErrorMessage(e?.message || xhrDefaultMessage);
                dispatch(setNotification(['Something went wrong,Please try again...', 'error']));
            })
    };

    const retryPayment = () => {
        if (!selectedMethod) return;
        setSubmitingPayment(true);
        setErrorMessage('');

        dispatch(purchasePaymentThunk({
            action: 'retry_payment_daily',
            payment_method_id: selectedMethod.id,
        }))
            .unwrap()
            .then(() => {
                setStep('Done');
                setSubmitingPayment(false);
                dispatch(getProfileDataThunk());
                dispatch(setNotification(['payment has been successfully confirmed', 'success']));

                dispatch(getSubsciptionHistoryThunk({
                    action: 'get_subscription_status',
                }));
            })
            .catch(e => {
                setSubmitingPayment(false);
                setErrorMessage(e?.message || xhrDefaultMessage);
                dispatch(setNotification(['Something went wrong,Please try again...', 'error']));
            })
    };

    return (
        <Modal
            size='sm'
            childClassName={styles.wrapper}
            title={step === 'Done' ? 'Successfull payment' : 'Choose a card to continue'}
            closeFunc={() => dispatch(setChooseCreditCardModal(false))}
            icon={step === 'Done' ? <SquareCheckIcon /> : <CreditCardIcon />}
        >
            {step === 'SelectPaymentMethod' && <>
                <span>Your Cards</span>
                {!fetching && paymentMethods?.map(method =>
                    <div className={styles.card} onClick={() => setSelectedMethod(method)}>
                        <CheckBox
                            checked={selectedMethod?.id === method.id}
                            onClick={() => setSelectedMethod(method)}
                        />
                        <div className={styles.card_info}>
                            <span>{method.card.brand}</span>
                            <span>Credit card ending in **** {method.card.last4}</span>
                        </div>
                    </div>)}
                {fetching && <Spinner />}
                <div
                    className={styles.add_new_card}
                    onClick={() => dispatch(setAddNewCardModal(true))}
                >
                    <PlusIcon />
                    <span>Add new credit or debit card</span>
                </div>
            </>}
            {errorMessage && <span className={styles.error}>{errorMessage}</span>}
            {step === 'Done' && <span className={styles.successfull}>
                Your payment has been successfully confirmed.
            </span>}
            <div className={styles.actions}>
                {step === 'SelectPaymentMethod' && <Button
                    type='Outline-Primary'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setChooseCreditCardModal(false))}
                />}
                <Button
                    type='Primary'
                    onClick={next}
                    disabled={!selectedMethod}
                    loading={submitingPayment}
                    className={styles.actions_btn}
                    text={step === 'SelectPaymentMethod' ? 'Pay' : 'Confirm'}
                />
            </div>
        </Modal>
    )
};
